import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class PriceElement extends HTMLElement {
  connectedCallback() {
    this.unsubscribeVariantChange = Pubsub.subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        this.handlePriceChange(html);
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handlePriceChange(html) {
    const priceElement = html.querySelector('price-element');
    this.innerHTML = priceElement.innerHTML;
  }
}

customElements.define('price-element', PriceElement);
